import React, { ReactNode } from 'react';
import { Switch, Route, Redirect, useLocation, RouteProps } from 'react-router-dom';
import {
    countDownPath,
    homePath,
    invitePath,
    dashboardPath,
    rankingPath,
    userGuidePath,
    luckyDrawPath,
} from 'constant/route-path';
import Dashboard from 'pages/Dashboard';
import LuckyDraw from 'pages/LuckyDraw';
import Ranking from 'pages/Ranking';
import CountDown from 'pages/CountDown';
import Home from 'pages/Home';
import Invite from 'pages/Invite';

import { observer } from 'mobx-react';
import Header from 'components/Header';
import styled from 'styled-components';
import classNames from 'classnames';
import Loading from './Loading';
import useAppLoading from 'hooks/useAppLoading';
import UserGuide from 'pages/UserGuide';
import Footer from 'components/Footer';

export const MainView = styled.div`
    position: relative;
    box-sizing: border-box;
    width: 1240px;
    margin: 0 auto;
    color: white;
    padding: 120px 20px 100px;
    background-size: cover;
    background-position: top center;
    z-index: 0;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        padding-top: 100px;
        padding-bottom: 60px;
        width: 100%;
    `}

    &.no-padding {
        background-image: none;
        padding-bottom: 0;
        padding-top: 0;
    }
    &.full {
        width: 100%;
        padding-left: 0;
        padding-right: 0;
        margin: 0;
    }
`;

interface PrivateRouteProps extends RouteProps {
    authed?: boolean;
    children: ReactNode;
}

const PrivateRoute = ({ children, ...rest }: PrivateRouteProps) => {
    const [authed] = useAppLoading();
    const location = useLocation();
    return (
        <Route
            {...rest}
            render={() => (authed ? children : <Redirect to={{ pathname: invitePath, search: location.search }} />)}
        />
    );
};

const whitelist = [userGuidePath];

const AppLoading = () => {
    const location = useLocation();
    const [userAuthed, appLoading] = useAppLoading();
    console.log('AppLoading userAuthed, appLoading ', userAuthed, appLoading);
    if (!whitelist.includes(location.pathname) && appLoading) {
        return <Loading />;
    }

    return (
        <>
            <Header />
            <MainView
                className={classNames('mainView', {
                    'no-padding':
                        [homePath, countDownPath, rankingPath, luckyDrawPath].includes(location.pathname) ||
                        location.pathname.startsWith(invitePath),
                    full:
                        [userGuidePath, luckyDrawPath].includes(location.pathname) ||
                        location.pathname.startsWith(invitePath),
                })}
            >
                <Switch>
                    <PrivateRoute path={homePath}>
                        <Home />
                    </PrivateRoute>
                    <Route path={`${invitePath}/:inviteCode`}>
                        <Invite />
                    </Route>
                    <Route path={invitePath}>
                        <Invite />
                    </Route>

                    <Route path={countDownPath}>
                        <CountDown />
                    </Route>

                    <PrivateRoute path={`${dashboardPath}`}>
                        <Dashboard />
                    </PrivateRoute>

                    <PrivateRoute path={`${luckyDrawPath}`}>
                        <LuckyDraw />
                    </PrivateRoute>

                    <PrivateRoute path={rankingPath}>
                        <Ranking />
                    </PrivateRoute>

                    <Route path={userGuidePath}>
                        <UserGuide />
                    </Route>

                    <Route path="*">
                        <Redirect to={{ pathname: userAuthed ? homePath : invitePath, search: location.search }} />
                    </Route>
                </Switch>
            </MainView>
            <Footer />
        </>
    );
};

export default observer(AppLoading);
